<!-- 
CustomerTypeModal.vue
功能：公司往來與狀況視窗
作者：i94004v014 Hugo
完成：2026-03-17
-->
<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog" style="width: 650px;">
      <div class="modal-content">
        <div class="modal-header">
          <a @click="$emit('close')" class="close">
            <i class="icon-close"></i>
          </a>
          <div>
            <span class="customer-type-title text-green">往來狀況與類型</span>
          </div>
        </div>
        <div class="modal-body">
          <div class="row">
              <span>篩選出國泰業務通路中，是否「具個人險有效契約之保單關係人(要保人、被保人)，或承保意外險、團體保險，或有申請房貸之客戶」</span>        
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonMixin } from "@/mixins/common";
export default {
  name: "CustomerTypeModal",
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  watch: {
    open: function(val) {
      if (val) {
        //this.registerHanlink(); // for hard word
      }
    }
  },
  data() {
    return {
      memo: [],
    };
  },
};
</script>
<style lang="scss" scoped>
.modal.fade .modal-body {
  min-height: 100px;
}

.modal-body .row {
  padding: 0px 20px;
}

.customer-type-title {
  font-size: 30px;
  font-weight: 600;
  margin-bottom: 0.5rem;
  margin-right: 0.5rem;
  font-family: inherit;
  line-height: 1.2;
}
.bg-green1 {
  background-color: rgb(0, 128, 0);
}

.bg-green2 {
  background-color: rgb(146, 208, 80);
}

.bg-gray {
  background-color: rgb(230, 230, 230);
}

.bg-orange1 {
  background-color: rgb(245, 136, 26);
}

.bg-orange2 {
  background-color: rgb(244, 177, 131);
}

.text-center {
  text-align: center;
}

.table.datatable {
  width: 90%;
  margin-left: 1.2rem;
  tbody {
    tr > td {
      &:first-child {
        padding-top: 10px;
      }
    }
  }
}

.modal-body {
    padding: 1rem !important;
}
</style>